import React, { useCallback, useMemo, useState } from 'react';
import {
  DEFAULT_ENV_KEY,
  ENVIRONMENTS,
  getEnvironmentByKey,
  persistEnvKey,
  readStoredEnvKey,
} from '../../environments';

export const EnvContext = React.createContext({});

const resolveEnvKey = (envOrKey) => {
  if (typeof envOrKey === 'string') {
    return ENVIRONMENTS[envOrKey] ? envOrKey : DEFAULT_ENV_KEY;
  }

  const found = Object.entries(ENVIRONMENTS).find(
    ([, config]) => config.botApi === envOrKey?.botApi
  );

  return found?.[0] || DEFAULT_ENV_KEY;
};

export const EnvProvider = ({ children }) => {
  const [environmentKey, setEnvironmentKeyState] = useState(readStoredEnvKey);

  const setEnvironmentKey = useCallback((key) => {
    const nextKey = resolveEnvKey(key);
    setEnvironmentKeyState(nextKey);
    persistEnvKey(nextKey);
  }, []);

  const environment = useMemo(
    () => getEnvironmentByKey(environmentKey),
    [environmentKey]
  );

  const value = useMemo(
    () => ({
      environment,
      environmentKey,
      setEnvironmentKey,
      setEnvironment: setEnvironmentKey,
    }),
    [environment, environmentKey, setEnvironmentKey]
  );

  return (
    <EnvContext.Provider value={value}>
      {children}
    </EnvContext.Provider>
  );
};
